import { BoxDocumentBloc } from "./bloc.box";
import { CloudDocumentBloc } from "./bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseDocumentBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseDocumentBloc>(environment.nexus, {
    box: new BoxDocumentBloc(),
    cloud: new CloudDocumentBloc(),
});